import React from 'react';
import { NavLink } from 'react-router-dom';
import logo from '../../assets/logo.png';
import {
  LayoutDashboard, Users, UserCheck, Building2,
  CalendarCheck, Settings, LogOut, Star,
} from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';

const navItems = [
  { to: '/admin/dashboard',      icon: LayoutDashboard, label: 'Tableau de bord' },
  { to: '/admin/proprietaires',  icon: UserCheck,       label: 'Propriétaires' },
  { to: '/admin/clients',        icon: Users,           label: 'Clients' },
  { to: '/admin/residences',     icon: Building2,       label: 'Résidences' },
  { to: '/admin/reservations',   icon: CalendarCheck,   label: 'Réservations' },
  { to: '/admin/avis',           icon: Star,            label: 'Avis' },
  { to: '/admin/parametres',     icon: Settings,        label: 'Paramètres' },
];

export default function AdminSidebar() {
  const { logout, userProfile } = useAuth();
  const navigate = useNavigate();

  async function handleLogout() {
    await logout();
    toast.success('Déconnecté');
    navigate('/');
  }

  return (
    <aside style={{
      position: 'fixed',
      top: 0, left: 0, bottom: 0,
      width: 'var(--sidebar-width)',
      background: '#1A1A2E',
      display: 'flex',
      flexDirection: 'column',
      zIndex: 100,
      boxShadow: '4px 0 20px rgba(0,0,0,0.2)',
    }}>
      {/* Logo */}
      <div style={{ padding: '1.5rem 1.25rem', borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
          <img src={logo} alt="ResiPro CI" style={{ width: 40, height: 40, borderRadius: 10, objectFit: 'contain', background: 'white', padding: 2 }} />
          <div>
            <div style={{ color: 'white', fontFamily: 'Poppins', fontWeight: 700, fontSize: '1rem' }}>ResiPro CI</div>
            <div style={{ color: 'rgba(255,255,255,0.45)', fontSize: '0.72rem', letterSpacing: '0.05em' }}>SUPER ADMIN</div>
          </div>
        </div>
      </div>

      {userProfile && (
        <div style={{ padding: '0.85rem 1.25rem', borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
          <div style={{ color: 'rgba(255,255,255,0.5)', fontSize: '0.75rem' }}>Connecté en tant que</div>
          <div style={{ color: 'white', fontWeight: 600, fontSize: '0.88rem', marginTop: 2 }}>
            {userProfile.prenom} {userProfile.nom}
          </div>
        </div>
      )}

      <nav style={{ flex: 1, padding: '0.75rem', display: 'flex', flexDirection: 'column', gap: '0.2rem', overflowY: 'auto' }}>
        {navItems.map(({ to, icon: Icon, label }) => (
          <NavLink
            key={to}
            to={to}
            style={({ isActive }) => ({
              display: 'flex',
              alignItems: 'center',
              gap: '0.75rem',
              padding: '0.7rem 0.75rem',
              borderRadius: 8,
              color: isActive ? 'white' : 'rgba(255,255,255,0.55)',
              background: isActive ? 'rgba(231,76,60,0.25)' : 'transparent',
              borderLeft: isActive ? '3px solid var(--danger)' : '3px solid transparent',
              fontWeight: isActive ? 600 : 400,
              fontSize: '0.88rem',
              transition: 'all 0.2s',
              textDecoration: 'none',
            })}
          >
            <Icon size={17} />
            {label}
          </NavLink>
        ))}
      </nav>

      <div style={{ padding: '0.5rem 1.25rem', textAlign: 'center' }}>
        <p style={{ fontSize: '0.65rem', color: 'rgba(255,255,255,0.2)', letterSpacing: '0.04em', lineHeight: 1.6 }}>
          <span style={{ fontWeight: 700, color: 'rgba(255,255,255,0.35)' }}>KONSTRUCT</span> by Constant<br />Powered by AI
        </p>
      </div>

      <div style={{ padding: '0.75rem' }}>
        <button
          onClick={handleLogout}
          style={{
            display: 'flex', alignItems: 'center', gap: '0.75rem',
            padding: '0.7rem 0.75rem', borderRadius: 8, width: '100%',
            color: 'rgba(255,255,255,0.5)', background: 'transparent',
            border: 'none', cursor: 'pointer', fontSize: '0.88rem', transition: 'all 0.2s',
          }}
          onMouseEnter={e => { e.currentTarget.style.background = 'rgba(231,76,60,0.2)'; e.currentTarget.style.color = 'white'; }}
          onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = 'rgba(255,255,255,0.5)'; }}
        >
          <LogOut size={17} />
          Déconnexion
        </button>
      </div>
    </aside>
  );
}
